module.exports = __webpack_public_path__ + "ploni-aaa-600.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-600.otf
// module id = 1200
// module chunks = 10